import React from 'react';

import kubernetesIcon from '@images/spe-cloud/kubernetes.svg';

export const kubernetesOpenshift = {
  mainSection: {
    icon: kubernetesIcon,
    elements: [
      {
        type: 'text',
        items: [
          <>
            <strong>Kubernetes (k8s for short)</strong> is an open-source container orchestration platform that enables
            automated application deployment, scaling and management.
          </>,
          <></>,
          <>
            Kubernetes can be used in private, public and hybrid clouds. It has become a go-to solution for deploying
            cloud-native apps.
          </>,
        ],
      },
      {
        type: 'list',
        description: <>Kubernetes allows you to:</>,
        items: [
          <>Automate container management across multiple hosts</>,
          <>Avoid vendor lock-in, as your apps are used on many underlying Operating Systems (OS)</>,
          <>Scale containerized applications for your current needs</>,
          <>Make better use of your hardware and thus save money</>,
          <>Heal automatically broken apps</>,
          <>Use the power of open source</>,
        ],
      },
      {
        type: 'list',
        description: (
          <>
            <strong>Red Hat OpenShift</strong> is a Kubernetes-based container platform that allows enterprises to
            automate operations management across hybrid cloud, multicloud, and edge deployments. It adds additional
            functionalities above and beyond a simple Kubernetes deployment:
          </>
        ),
        items: [
          <>A management console to manage Kubernetes clusters</>,
          <>Monitoring of Kubernetes clusters and containers</>,
          <>Analytics to provide actionable insights</>,
          <>Authentication to ensure higher security</>,
        ],
      },
    ],
  },
  howWeHelpSection: {
    elements: [
      {
        type: 'list',
        items: [
          <>Provide assessment and architectural consulting</>,
          <>Prepare an implementation and migration plan</>,
          <>Build integrations with other solutions</>,
          <>Extend your existing automation (CI/CD, QA)</>,
          <>Ensure proper monitoring of K8s-based deployments</>,
          <>Ensure the security of applications managed by K8s</>,
        ],
      },
    ],
    relatedResources: [
      {
        type: 'Case study',
        items: [
          {
            title: 'Integration of Tungsten Fabric SDN controller with Red Hat OpenShift Kubernetes-based platform',
            link: '/case-study/integration-of-tungsten-fabric-sdn-controller-with-red-hat-openshift-kubernetes-based-platform/',
          },
          {
            title: 'An automatic data center and low-level network infrastructure management',
            link: '/case-study/automatic-data-center-and-low-level-network-infrastructure-management-solution/',
          },
        ],
      },
      // {
      //   type: 'Blog posts',
      //   items: [
      //     {
      //       title: 'Harnessing the power of Kubernetes: 7 use cases',
      //       link: '/harnessing-the-power-of-kubernetes-7-use-cases/',
      //     },
      //     {
      //       title: 'How to create a custom resource with Kubernetes Operator',
      //       link: '/how-to-create-a-custom-resource-with-kubernetes-operator/',
      //     },
      //     {
      //       title: 'Kubernetes workloads—using multiple networks',
      //       link: '/kubernetes-workloads-using-multiple-networks/',
      //     },
      //   ],
      // },
      // {
      //   type: 'White paper',
      //   items: [
      //     {
      //       title: 'Into the cloud with Kubernetes',
      //       link: '/pdf/CodiLime-Into_the_Cloud_with_Kubernetes.pdf',
      //     },
      //     {
      //       title: 'How to make your Kubernetes cluster secure',
      //       link: '/pdf/CodiLime-Kubernetes_Security.pdf',
      //     },
      //   ],
      // },
    ],
  },
};
